import { _isNaN } from './nodash';

export const isEmpty = (obj) => {
    // handle undefined/null/{}/{"field":"value"}/[]/[1,2,3]
    return !obj || (!!obj && Object.keys(obj).length === 0);
};

export const haveSameKeys = (obj1, obj2) => {
    const obj1Keys = Object.keys(obj1),
        obj2Keys = Object.keys(obj2);

    return obj1Keys.length === obj2Keys.length && obj1Keys.every((key) => obj2Keys.indexOf(key) > -1);
};

/**
 *
 * shallow equality
 */
export const areEqual = (obj1, obj2) => {
    if (!haveSameKeys(obj1, obj2)) {
        return false;
    }

    const obj1Keys = Object.keys(obj1);

    for (let i = 0; i < obj1Keys.length; i++) {
        let key = obj1Keys[i];
        if (_isNaN(obj1[key]) && _isNaN(obj2[key])) {
            return true;
        }
        if (obj1[key] !== obj2[key]) {
            return false;
        }
    }

    return true;
};

export const removeNulls = (obj) => {
    return Object.keys(obj)
        .filter((k) => obj[k] != null)
        .reduce((newObj, k) => {
            if (Array.isArray(obj[k])) {
                return { ...newObj, [k]: [...obj[k]] };
            } else if (typeof obj[k] === 'object') {
                return { ...newObj, [k]: removeNulls(obj[k]) };
            } else {
                return { ...newObj, [k]: obj[k] };
            }
        }, {});
};

/**
 * Returns the value of the provided key in the object
 * multiple keys can be provided for nested values in the object
 * If no match is found, then undefined is returned
 * @param {object} obj
 * @param {string[]} keys
 * @returns {*}
 */
export const getNestedValueFromKey = (obj, ...keys) => {
    return keys.reduce((obj, key) => obj && obj[key], obj);
};

/**
 * Returns the object with the corresponding mapped values for the keys
 * @param {object} obj
 * @param {function} iterate
 * @returns {object}
 */
export const mapObject = (obj, iterate) => {
    return Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, iterate(value, key, obj)]));
};
